/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_SeptemberInputs */

const he_month_september = /** @type {(inputs: Month_SeptemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ספטמבר`)
};

const en_month_september = /** @type {(inputs: Month_SeptemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`September`)
};

/**
* | output |
* | --- |
* | "September" |
*
* @param {Month_SeptemberInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_september = /** @type {((inputs?: Month_SeptemberInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_SeptemberInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_september(inputs)
	return en_month_september(inputs)
});